module.exports = __webpack_public_path__ + "img/pencil-outline-disable.2fcc39d6.svg";